import React, { useRef } from "react";
import ClientsSlider from "../Header/ClientsSlider";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import SliderImg1 from "../../assets/s-2.jpeg";
import SliderImg2 from "../../assets/s-3.jpeg";
import SliderImg3 from "../../assets/s-1.jpeg"




const Hero = () => {
    const swiperRef = useRef(null); // Create a ref to the Swiper instance

    return (
        <React.Fragment>
            {/* <Header /> */}
            {/* Swiper Section */}
            <div className="slider-container relative">
                <Swiper
                    ref={swiperRef}
                    modules={[Autoplay]}
                    spaceBetween={50}
                    slidesPerView={1}
                    loop={true}
                    autoplay={{
                      delay: 3000,
                      disableOnInteraction: false,
                    }}
                    allowTouchMove={false}
                >
                    <SwiperSlide>
    <section
        className="relative light py-32 md:py-52 h-[90vh] md:h-[85vh] text-white bg-cover bg-center bg-no-repeat"
        style={{
            backgroundImage: `url(${SliderImg2})`,
        }}
    >
        {/* Black Overlay */}
        <div className="absolute inset-0 bg-black opacity-50"></div>

        {/* Content on top of the overlay */}
        <div className="container px-4 mx-auto relative z-10">
            <div className="md:max-w-5xl mx-auto flex justify-center items-center text-center">
                <div>
                    <h1 className="text-3xl font-bold leading-tight md:text-[62px] mb-2 capitalize">
                        Secure your future with tailored Financial Solutions
                    </h1>
                    <p className="text-xl opacity-80 leading-snug px-12 py-6">
                        We provide expert financial advice, innovative investment
                        strategies, and personalized solutions to help you build and
                        protect your wealth for a secure and prosperous future
                    </p>
                </div>
            </div>
        </div>
    </section>
</SwiperSlide>

<SwiperSlide>
    <section
        className="relative light py-32 md:py-52 h-[85vh] text-white bg-cover bg-center bg-no-repeat"
        style={{
            backgroundImage: `url(${SliderImg1})`,
        }}
    >
        {/* Black Overlay */}
        <div className="absolute inset-0 bg-black opacity-50"></div>

        {/* Content on top of the overlay */}
        <div className="container px-4 mx-auto relative z-10">
            <div className="md:max-w-5xl mx-auto flex justify-center items-center text-center">
                <div>
                    <h1 className="text-3xl font-bold leading-tight md:text-[62px] mb-2 capitalize">
                        Empower Your Financial Journey with Expert Guidance
                    </h1>
                    <p className="text-xl opacity-80 leading-snug px-12 py-6">
                        Our team offers personalized financial strategies, innovative investment
                        solutions, and dedicated support to help you achieve your financial goals
                    </p>
                </div>
            </div>
        </div>
    </section>
</SwiperSlide>

<SwiperSlide>
    <section
        className="relative light py-32 md:py-52 h-[85vh] text-white bg-cover bg-center bg-no-repeat"
        style={{
            backgroundImage: `url(${SliderImg3})`,
        }}
    >
        {/* Black Overlay */}
        <div className="absolute inset-0 bg-black opacity-50"></div>

        {/* Content on top of the overlay */}
        <div className="container px-4 mx-auto relative z-10">
            <div className="md:max-w-5xl mx-auto flex justify-center items-center text-center">
                <div>
                    <h1 className="text-3xl font-bold leading-tight md:text-[62px] mb-2 capitalize">
                        Discover Innovative Solutions for Your Business Growth
                    </h1>
                    <p className="text-xl opacity-80 leading-snug px-12 py-6">
                        Our team specializes in delivering cutting-edge strategies and tools to
                        help your business thrive in a competitive market. Let's build a
                        successful future together
                    </p>
                </div>
            </div>
        </div>
    </section>
</SwiperSlide>

                </Swiper>
            </div>

            <ClientsSlider />
        </React.Fragment>
    );
};

export default Hero;
